export default {"src":"/_next/static/media/calendar.3ccff5e2.svg","height":19,"width":19};